import React, { useState } from 'react';

const SECTIONS = {
  apropos: {
    title: 'À propos de Havenly',
    content: [
      {
        heading: "Notre histoire",
        text: `Havenly est née d'un constat simple : les plateformes de location courte durée existantes ne servent pas correctement les hôtes et voyageurs français.

Des commissions trop élevées (15,5% chez Airbnb, 17% chez Booking), des versements tardifs, une communication avec les voyageurs chronophage, des litiges mal gérés — nous avons décidé de faire différemment.

Havenly est une plateforme 100% française, pensée pour le marché français, avec des règles adaptées à notre législation et notre culture de l'hospitalité.`,
      },
      {
        heading: "Notre mission",
        text: `Rendre la location courte durée plus juste, plus transparente et plus humaine — pour les hôtes comme pour les voyageurs.

Pour les hôtes : moins de commission, plus de revenus, moins de gestion grâce à Emma IA.

Pour les voyageurs : prix final garanti dès la recherche, hôtes vérifiés, litiges résolus en 72h.

Pour la France : une alternative française aux plateformes américaines, qui respecte notre droit et nos usages.`,
      },
      {
        heading: "Nos valeurs",
        text: `Transparence : le prix affiché est le prix final. Nos commissions sont publiques. Nos règles sont claires.

Équité : 8% de commission pour les fondateurs, 12% pour tous — contre 15,5% à 17% ailleurs. Les hôtes méritent de garder leurs revenus.

Innovation : Emma IA répond en 4 langues en 30 secondes. La technologie au service de l'humain, pas l'inverse.

Protection : séquestre, dépôt de garantie, médiation sous 72h. Nous protégeons les deux parties à chaque réservation.`,
      },
      {
        heading: "L'équipe",
        text: `Havenly est portée par une équipe passionnée de voyages et de technologie, convaincue que le marché français mérite mieux.

Nous sommes basés à Paris et recrutons activement. Si vous partagez notre vision, consultez nos offres dans la section Carrières.`,
      },
      {
        heading: "Chiffres clés (beta)",
        text: `• Lancement : janvier 2025
- Logements en beta : 27
- Hôtes fondateurs : 27 / 50
- Villes couvertes : Côte d'Azur, Provence, Pays Basque, Corse, Paris, Lyon, Bordeaux, Annecy, Strasbourg
- Commission hôtes fondateurs : 8% (vs 15,5% Airbnb)
- Ouverture voyageurs : été 2026`,
      },
    ],
  },

  presse: {
    title: 'Espace presse',
    content: [
      {
        heading: "Havenly en bref",
        text: `Havenly est une plateforme française de location courte durée lancée en 2025. Elle se distingue par :

- Une commission de 8% pour les hôtes fondateurs (vs 15,5% Airbnb)
- Emma IA — assistante qui répond aux voyageurs en 4 langues, 24h/24
- Un prix final affiché dès la recherche, sans frais cachés
- Une médiation des litiges garantie sous 72h
- Un versement aux hôtes sous 24h après chaque check-out

Statut actuel : phase beta avec 27 logements. Ouverture grand public prévue été 2026.`,
      },
      {
        heading: "Éléments de langage",
        text: `Havenly est...
- "La première plateforme de location courte durée 100% française"
- "La plateforme qui rend la location plus juste pour les hôtes et les voyageurs"
- "L'alternative française à Airbnb avec 8% de commission"

Havenly n'est pas...
- Un clone d'Airbnb
- Une plateforme de luxe exclusivement
- Uniquement pour les propriétaires de villas`,
      },
      {
        heading: "Contacts presse",
        text: `Pour toute demande d'interview, de partenariat éditorial ou d'information :

Email presse : presse@havenly.fr
Réponse garantie sous 48h ouvrées.

Kit presse (logos, visuels, fiches produit) : disponible sur demande à presse@havenly.fr`,
      },
      {
        heading: "Revue de presse",
        text: `Havenly vient de lancer sa phase beta — notre revue de presse sera mise à jour au fil des parutions.

Vous souhaitez couvrir Havenly ? Contactez-nous à presse@havenly.fr pour organiser une démonstration ou une interview de nos fondateurs.`,
      },
    ],
  },

  investisseurs: {
    title: 'Investisseurs',
    content: [
      {
        heading: "La thèse d'investissement",
        text: `Le marché de la location courte durée en France représente plus de 4 milliards d'euros par an. Airbnb y capte environ 2 milliards, avec une commission de 15,5% jugée trop élevée par les hôtes.

Havenly adresse ce marché avec une proposition claire : moins de commission, mieux géré, 100% français. Notre modèle est prouvé — nos hôtes fondateurs génèrent en moyenne 2 400€/mois.`,
      },
      {
        heading: "Notre modèle économique",
        text: `Revenus principaux :
- Commission sur les réservations : 8% (fondateurs) ou 12% (standard)
- Services premium hôtes (à venir) : visibilité boostée, photographie professionnelle
- Emma IA pour tiers (à venir) : API Emma pour d'autres plateformes

Unit economics :
- GMV cible année 1 : 500 000€
- Commission moyenne : 10%
- Revenus nets cibles année 1 : 50 000€`,
      },
      {
        heading: "Stade de développement",
        text: `Janvier 2025 : lancement beta avec 27 logements
Été 2026 : ouverture grand public (objectif 200 logements)
2027 : expansion nationale (objectif 1 000 logements)

Nous levons actuellement une première seed pour accélérer le développement produit et le marketing.`,
      },
      {
        heading: "Contact investisseurs",
        text: `Pour toute demande d'information ou de rencontre :

Email : invest@havenly.fr
Deck disponible sur demande sous NDA.

Nous privilégions les investisseurs alignés avec notre vision d'une plateforme française éthique et durable.`,
      },
    ],
  },

  carrieres: {
    title: 'Carrières',
    content: [
      {
        heading: "Rejoignez l'aventure Havenly",
        text: `Havenly est en phase de lancement — c'est le moment idéal pour rejoindre une startup ambitieuse et construire quelque chose de nouveau.

Nous cherchons des personnes passionnées, autonomes et convaincues que le marché français de la location mérite mieux. Si vous voulez avoir un impact réel dès le premier jour, vous êtes au bon endroit.`,
      },
      {
        heading: "Postes ouverts",
        text: `Développeur Full Stack (React / Node.js / Supabase)
Missions : améliorer la plateforme, développer de nouvelles fonctionnalités, intégrer des APIs partenaires.
Profil : 3+ ans d'expérience, passion pour le produit, à l'aise en autonomie.

Growth Hacker / Marketing Digital
Missions : acquisition hôtes et voyageurs, SEO, réseaux sociaux, partenariats.
Profil : expérience en growth, créatif, orienté résultats.

Account Manager Hôtes
Missions : accompagner les hôtes dans leur onboarding, les aider à optimiser leurs annonces.
Profil : excellent relationnel, connaissance du secteur immobilier ou tourisme.`,
      },
      {
        heading: "Ce que nous offrons",
        text: `• Salaire compétitif + BSPCE (bons de souscription de parts de créateur d'entreprise)
- Remote-first — travaillez où vous voulez
- Équipe à taille humaine — vos idées comptent vraiment
- Impact direct — vous voyez le résultat de votre travail chaque jour
- Cadre de travail Paris si souhaité`,
      },
      {
        heading: "Candidature spontanée",
        text: `Vous ne trouvez pas le poste qui vous correspond mais vous croyez en Havenly ?

Envoyez votre CV et une lettre de motivation à carrieres@havenly.fr

Nous lisons toutes les candidatures et répondons sous 7 jours.`,
      },
    ],
  },

  blog: {
    title: 'Blog Havenly',
    content: [
      {
        heading: "Le blog arrive bientôt",
        text: `Notre blog sera lancé courant 2025 avec des contenus pensés pour les hôtes et voyageurs français.

Au programme :
- Guides pratiques pour maximiser ses revenus locatifs
- Actualités juridiques et fiscales (Loi Le Meur, fiscalité BIC...)
- Destinations tendance en France
- Témoignages d'hôtes Havenly
- Conseils déco et aménagement pour attirer plus de voyageurs`,
      },
      {
        heading: "Premiers articles prévus",
        text: `Comment photographier son logement comme un pro (sans équipement professionnel)

Loi Le Meur 2024 : ce qui change pour les hôtes en 2025

Côte d'Azur vs Provence : où investir dans la location saisonnière ?

Emma IA : comment l'intelligence artificielle révolutionne l'accueil des voyageurs

Fiscalité 2025 : Micro-BIC ou régime réel — que choisir ?`,
      },
      {
        heading: "Contribuer au blog",
        text: `Vous êtes hôte Havenly et souhaitez partager votre expérience ? Vous êtes expert en droit immobilier, fiscal ou en décoration ?

Nous acceptons les contributions externes sur des sujets liés à la location courte durée en France.

Contactez-nous : blog@havenly.fr`,
      },
    ],
  },

  parrainage: {
    title: 'Programme de parrainage',
    content: [
      {
        heading: "Gagnez 30€ en parrainant un hôte",
        text: `Vous connaissez un propriétaire qui pourrait bénéficier de Havenly ? Parrainez-le et gagnez 30€ de crédit commission dès sa première réservation complétée.

Votre filleul bénéficie de 10% de commission réduite pendant ses 3 premiers mois — un avantage concret pour démarrer.

Le programme de parrainage est illimité — vous pouvez parrainer autant d'hôtes que vous le souhaitez.`,
      },
      {
        heading: "Comment ça marche ?",
        text: `1. Connectez-vous à votre tableau de bord Havenly
2. Rendez-vous dans l'onglet "Parrainer"
3. Copiez votre lien de parrainage personnel
4. Partagez-le à vos contacts propriétaires
5. Dès que votre filleul complète sa première réservation, 30€ sont crédités sur votre compte

Le crédit est automatiquement déduit de votre prochaine commission — aucune démarche supplémentaire.`,
      },
      {
        heading: "Conditions du parrainage",
        text: `• Le filleul doit s'inscrire via votre lien personnel
- Le filleul doit publier une annonce vérifiée par Havenly
- Le crédit est attribué après la première réservation complétée (check-out effectué)
- Le crédit est valable 12 mois
- Le parrainage ne s'applique pas aux comptes existants Havenly
- Havenly se réserve le droit de suspendre le programme en cas d'abus`,
      },
      {
        heading: "Accéder à votre lien de parrainage",
        text: `Votre lien de parrainage est disponible dans votre tableau de bord, onglet "Parrainer".

Si vous n'êtes pas encore hôte, créez votre compte gratuitement pour accéder au programme.`,
      },
    ],
  },
};

export default function HavenlyPage({ onNavigate, havenlyPage }) {
  const [activePage, setActivePage] = useState(havenlyPage || 'apropos');
  const isMobile = window.innerWidth < 768;
  const section = SECTIONS[activePage] || SECTIONS['apropos'];

  const tabs = [
    { key: 'apropos', label: 'À propos' },
    { key: 'presse', label: 'Presse' },
    { key: 'investisseurs', label: 'Investisseurs' },
    { key: 'carrieres', label: 'Carrières' },
    { key: 'blog', label: 'Blog' },
    { key: 'parrainage', label: 'Parrainage' },
  ];

  return (
    <div style={{ background: 'var(--surface)', minHeight: '100vh', paddingTop: 60 }}>
      <div style={{ background: 'var(--white)', borderBottom: '1px solid var(--border)', padding: isMobile ? '1.5rem 1rem 0' : '2rem 2rem 0' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <button onClick={() => onNavigate('home')} style={{ background: 'none', border: 'none', fontSize: 13, color: 'var(--ink-3)', cursor: 'pointer', padding: 0, marginBottom: 12 }}>
            ← Retour
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg viewBox="0 0 210 52" style={{ height: 20, width: 'auto' }} xmlns="http://www.w3.org/2000/svg">
                <text x="0" y="44" fontFamily="Georgia,serif" fontSize="52" fontWeight="400" fontStyle="italic" letterSpacing="-2" fill="#1D9E75">haven<tspan fill="#0F6E56" dx="-3">ly</tspan></text>
              </svg>
            </div>
            <h1 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 22 : 28, letterSpacing: '-0.5px' }}>
              Havenly
            </h1>
          </div>
          <div style={{ display: 'flex', gap: 0, overflowX: 'auto' }}>
            {tabs.map(tab => (
              <button key={tab.key} onClick={() => setActivePage(tab.key)} style={{
                padding: isMobile ? '10px 12px' : '12px 20px',
                border: 'none', background: 'transparent', cursor: 'pointer',
                fontFamily: 'var(--sans)', fontSize: isMobile ? 12 : 14,
                borderBottom: activePage === tab.key ? '2px solid var(--ink)' : '2px solid transparent',
                color: activePage === tab.key ? 'var(--ink)' : 'var(--ink-3)',
                fontWeight: activePage === tab.key ? 500 : 400,
                whiteSpace: 'nowrap',
              }}>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: '0 auto', padding: isMobile ? '1.5rem 1rem' : '2.5rem 2rem' }}>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: isMobile ? '1.5rem' : '2.5rem' }}>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 20 : 26, letterSpacing: '-0.5px', marginBottom: 32 }}>
            {section.title}
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
            {section.content.map((block, i) => (
              <div key={i}>
                <h3 style={{ fontSize: 15, fontWeight: 500, marginBottom: 10 }}>{block.heading}</h3>
                <div style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                  {block.text}
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 40, display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
            <div style={{ padding: '20px 24px', background: 'var(--green-light)', border: '1px solid var(--green)', borderRadius: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--green-mid)', marginBottom: 6 }}>Rejoindre Havenly</div>
              <div style={{ fontSize: 13, color: 'var(--green-mid)', lineHeight: 1.6, marginBottom: 12 }}>
                8% de commission · Emma IA incluse · Versement 24h
              </div>
              <button onClick={() => onNavigate('becomehost')} style={{ fontSize: 13, fontWeight: 500, color: '#fff', background: 'var(--green)', border: 'none', borderRadius: 20, padding: '7px 16px', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                Devenir hôte →
              </button>
            </div>
            <div style={{ padding: '20px 24px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 6 }}>Nous contacter</div>
              <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.6 }}>
                contact@havenly.fr
                presse@havenly.fr
                invest@havenly.fr
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}